module.exports = __webpack_public_path__ + "img/Loading_xh_5.35bbe9f6.png";